import { ThumbsUpButton } from "./ThumbsUpButton";

export default ThumbsUpButton;
